const USD = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 })
const USD2 = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2 })

export const fmtUSD  = (n) => USD.format(n ?? 0)
export const fmtUSD2 = (n) => USD2.format(n ?? 0)
export const fmtPct  = (n) => `${(n ?? 0).toFixed(1)}%`
export const fmtNum  = (n) => new Intl.NumberFormat('en-US').format(n ?? 0)

export function fmtDate(iso) {
  if (!iso) return '—'
  return new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
}

export function daysAgo(iso) {
  if (!iso) return null
  const diff = Date.now() - new Date(iso).getTime()
  return Math.floor(diff / 86_400_000)
}
